import {Component, computed, DestroyRef, inject, input, Input, OnInit, ViewChild} from '@angular/core';
import {SwissFieldBase} from '../fields/swiss-field-base';
import {FormGroupDirective, UntypedFormGroup} from '@angular/forms';
import {MatSelect, MatSelectChange} from '@angular/material/select';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {ObjektModels} from 'src/app/models/objekt-models';
import {MatDialog} from '@angular/material/dialog';
import {ObjektAdresseComponent} from 'src/app/home-layout/objekte/objekt-adresse/objekt-adresse.component';
import {AdresseDataService} from 'src/app/services/adresse-data.service';
import {HelperService} from '../../services/helper.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {BehaviorSubject} from "rxjs";

@Component({
    selector: 'app-swiss-dynamic-form',
    templateUrl: './swiss-dynamic-form.component.html',
    styleUrls: ['./swiss-dynamic-form.component.scss'],
})
export class SwissDynamicFormComponent implements OnInit {
    @Input() swissField!: SwissFieldBase<any>;
    form!: UntypedFormGroup;
    @ViewChild('select') select!: MatSelect;
    ignoreStyling = input(false);
    objectType$ = input<string | null>();

    private destroyRef = inject(DestroyRef);
    /* Adressauswahl */
    private objektAdresseDialogInput?: ObjektModels.ObjektAdresseDialogInput;

    constructor(private data: ObjektDataService,
                private rootFormGroup: FormGroupDirective,
                public dialog: MatDialog,
                private svcAdressen: AdresseDataService,
                public helperService: HelperService) {
        this.form = this.rootFormGroup.control;
    }

    get isValid() {
        if (this.form && this.swissField && this.swissField.options && this.swissField.options.key) {
            if (Object.keys(this.form.controls).length > 0) {
                if (this.form.controls[this.swissField.options.key]) {
                    // Inaktive Felder (z.B. bei fehlender Berechtigung müssen nicht validiert werden)
                    if (this.form.controls[this.swissField.options.key].status == 'DISABLED') {
                        return true;
                    } else {
                        return this.form.controls[this.swissField.options.key].valid;
                    }
                } else {
                    return false;
                }
            }
            return true;
        }
        return false;
    }

    ngOnInit(): void {
        if (this.swissField.options.readOnly) {
            this.form.controls[this.swissField.options.key!].disable();
        } else {
            if (this.helperService.isWebServiceAvailable()) {
                this.form.controls[this.swissField!.options!.key!].enable();
            } else {
                this.form.controls[this.swissField!.options!.key!].disable();
            }
        }

        if (this.swissField.options.key === 'ObjTyp' && this.swissField.isNewEntity) {
            this.form.controls[this.swissField!.options!.key!].patchValue(this.swissField.options.optionsNeu[0].key);
        }

        this.helperService.getOnlineStateChanged().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((state) => {
            if (state && !this.swissField.options.readOnly) {
                this.form.controls[this.swissField!.options!.key!].enable();
            } else {
                this.form.controls[this.swissField!.options!.key!].disable();
            }
        });
    }

    addObjectAddress() {
        this.objektAdresseDialogInput = {
            objektAdresseZuord: {
                id: '00000000-0000-0000-0000-000000000000',
                objectID: '',
                addressType: 1, // CUSTOMER
                addressContact: 0,
                adressNumber: 0,
                adressID: '',
            },
            blDoCheckUnique: false,
            blDisableAdrTypeSelect: false,
        };

        const dialogRefOA = this.dialog.open(ObjektAdresseComponent, {
            disableClose: true,
            width: '95%',
            maxHeight: '90vh',
            data: this.objektAdresseDialogInput,
        });

        dialogRefOA.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.objektAdresseDialogInput!.objektAdresseZuord = result;
                    this.data.callAddAdressInObjectDialog(this.objektAdresseDialogInput!.objektAdresseZuord);
                }
            },
        });
    }

    dropdownSelectionChange(event: MatSelectChange): void {
        if (event.value === null) {
            event.source.ngControl.control!.patchValue('');
        }
    }

    onZIPChange(event: Event) {
        const zip = (event.target as HTMLInputElement).value;

        if (zip.length >= 4) {
            this.svcAdressen.getCityByZip(zip).then((res) => {
                if (res) {
                    if (this.form.controls.ObjOrt) {
                        this.form.controls.ObjOrt.setValue(res.town);
                    }
                }
            });
        }
    }

    protected setObjectNumberRange($event: { key: string, value: string | undefined }): void {
        this.form.controls[$event.key].patchValue($event.value);
    }
}
